webpackJsonp([131728595368307],{

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(133);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Remove Parsing'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll refactor our code so that we can remove the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method we added to get our application to work after setting up the real API.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While we could continue to use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method, refactoring our code will make some of the later steps a little simpler.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'cleanup.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Refactor Tweet Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To start, open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ' component. Locate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connect'
	      ),
	      ' call and replace ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'userId'
	      ),
	      ' with ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      ', like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Tweet.js\n        connect(function(getState, props) {\n          const { tweet } = props;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Tweet.js\n        export default connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(Tweet);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Tweet.js\n        @connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        });\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With this change, we\'ve removed the dependency we had on the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'userId'
	      ),
	      ' attribute from the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'json-api'
	      ),
	      ' server, and no longer have a reason for our custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Remove Parse from Tweet Model'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next open ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/components/tweet.js'
	      ),
	      ' and locate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method that currently looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/models/tweet.js\n      export default {\n        ...\n        properties: {\n          parse: function(response, options) {\n            response.userId = response.user;\n            return response;\n          }\n        }\n        ...\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since we no longer need it, delete the function, or convert it back to it\'s commented out default, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/models/tweet.js\n      export default {\n        ...\n        properties: {\n          // parse: function(response, options) {\n          //  return response;\n          // }\n        }\n        ...\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With these changes, your application should still work.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should look like this (exactly the same):'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Tweet.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n\n        export default connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(\n        createReactClass({\n          displayName: \'Tweet\',\n\n          propTypes: {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          },\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                </div>\n              </li>\n            );\n          }\n\n        })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n\n        class Tweet extends React.Component {\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        Tweet.propTypes = {\n          tweet: PropTypes.object.isRequired,\n          user: PropTypes.object.isRequired\n        };\n\n        export default connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(Tweet);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n\n        @connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })\n        class Tweet extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        export default Tweet;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/models/tweet.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default {\n\n      };\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to add dialogs to our application ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../dialogs/overview/' },
	        'so we can create, update and delete tweets'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-cleanup-step-1-js-7fb8a3f203b669e39125.js